import React, { useState } from 'react';
import { TrendingUp, Activity, DollarSign, Bitcoin, BarChart3, Gem } from 'lucide-react';
import TradingViewMarketOverview, { MARKET_TABS } from './TradingViewMarketOverview';

const TAB_ICONS = { forex: DollarSign, crypto: Bitcoin, indices: BarChart3, commodities: Gem };

const LiveMarketData = () => {
  const [category, setCategory] = useState('forex');

  return (
    <section id="live-markets" className="relative bg-gradient-to-b from-black via-slate-950 to-black py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(16, 185, 129, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(16, 185, 129, 0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full mb-6">
            <Activity className="w-4 h-4 text-emerald-400 animate-pulse" />
            <span className="text-emerald-400 text-sm font-semibold tracking-wide">LIVE MARKET DATA</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
            Real-Time{' '}
            <span className="bg-gradient-to-r from-emerald-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Market Prices
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
            Track live prices across Forex, Crypto, Indices, and Commodities. Tap a market below, then tap any symbol to view its chart.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-6" role="tablist" data-testid="market-category-tabs">
          {Object.entries(MARKET_TABS).map(([key, tab]) => {
            const Icon = TAB_ICONS[key];
            const active = category === key;
            return (
              <button
                key={key}
                role="tab"
                aria-selected={active}
                data-testid={`market-tab-${key}`}
                onClick={() => setCategory(key)}
                className={`inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl text-sm sm:text-base font-bold transition-all duration-300 ${
                  active
                    ? 'bg-gradient-to-r from-emerald-500 to-cyan-500 text-black shadow-lg shadow-emerald-500/40'
                    : 'bg-slate-800/50 text-slate-300 border border-slate-700/50 hover:bg-slate-800 hover:text-white'
                }`}
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                {tab.title}
              </button>
            );
          })}
        </div>

        {/* TradingView Market Overview Widget */}
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-slate-900/80 to-slate-950/80 backdrop-blur-xl border border-slate-800/50 rounded-3xl p-3 sm:p-4 lg:p-8 shadow-2xl overflow-hidden">
            <TradingViewMarketOverview key={category} category={category} />
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="flex items-center justify-center gap-2 text-slate-500 text-sm">
            <TrendingUp className="w-4 h-4" />
            <span>Live data updates every few seconds • Powered by TradingView</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveMarketData;
